import { z } from "zod";

export const amqpConfigurationSchema = z
	.object({
		isEnabled: z.boolean(),
		uri: z.string().nullish(),
		exchange: z.string().optional(),
		routingKeyPattern: z.string().optional(),
	})
	.superRefine((data, ctx) => {
		// Only validate when AMQP is enabled
		if (data.isEnabled !== true) {
			return;
		}

		// Validate URI format
		if (!data.uri || data.uri === "" || !/^amqps?:\/\//i.test(data.uri)) {
			ctx.addIssue({
				code: "custom",
				path: ["uri"],
				message: "Uri must start with amqp:// or amqps://",
			});
		}

		// Validate exchange is required
		if (!data.exchange || data.exchange === "") {
			ctx.addIssue({
				code: "custom",
				path: ["exchange"],
				message: "Exchange Name is required",
			});
		}

		// Validate routingKeyPattern is required
		if (!data.routingKeyPattern || data.routingKeyPattern === "") {
			ctx.addIssue({
				code: "custom",
				path: ["routingKeyPattern"],
				message: "Routing Key Pattern is required",
			});
		}
	});
export type AmqpConfiguration = z.infer<typeof amqpConfigurationSchema>;
